import { IJobpost, TIndustry } from '../interfaces/jobpost.interface';

/**
 * Extract industries array from jobpost's jobpostIndustries join table
 * @param jobpost - Jobpost object with jobpostIndustries
 * @returns Array of industry objects
 */
export const getIndustries = (
  jobpost: IJobpost | undefined | null
): TIndustry[] => {
  if (!jobpost || !jobpost.jobpostIndustries) {
    return [];
  }
  return jobpost.jobpostIndustries.map((ji) => ji.industry);
};

/**
 * Get industry IDs array from jobpost for form submission
 * @param jobpost - Jobpost object with jobpostIndustries
 * @returns Array of industry IDs
 */
export const getIndustryIds = (
  jobpost: IJobpost | undefined | null
): string[] => {
  if (!jobpost || !jobpost.jobpostIndustries) {
    return [];
  }
  return jobpost.jobpostIndustries.map((ji) => ji.industryId);
};
